import React from 'react';
import style from './styles.module.scss';
import cn from 'classnames';

const Radio = (props) => {
  return (
    <div className={style.radio}>
      <input
        type='radio'
        id={props.id}
        name={props.name}
        value={props.id}
        checked={props.checked}
        onChange={props.onChange}
        disabled={props.disabled}
      />
      <label htmlFor={props.id}>{props.label}</label>
    </div>
  );
};

const RadioButton = ({options, checked, disabled, onChange, className}) => {
  return (
    <div className={cn(style.radioGroup, className)}>
      {
        options.map((option, index) => {
          const isChecked = checked === option.id
          return (
            <Radio
              key={index}
              onChange={onChange}
              checked={isChecked}
              disabled={disabled}
              {...option} />
          )
        })
      }
    </div> 
  );
}

export default RadioButton
